import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";
import { siteInfo } from "@/mocks/site";

export default function CtaBanner() {
  return (
    <section className="w-full max-w-7xl mx-auto px-4 md:px-8 py-14 md:py-20">
      <Reveal>
        <div className="relative overflow-hidden rounded-lg bg-gradient-to-br from-primary-600 via-primary-500 to-accent-500">
          <div className="relative z-10 px-6 md:px-12 py-10 md:py-14 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8">
            <div className="max-w-2xl">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 leading-tight">
                手上有瓜？现在就可以投喂
              </h2>
              <p className="mt-3 text-sm md:text-base text-background-50/95 leading-relaxed">
                填写投稿表单，或直接私信投稿。线索直达后台审核，投稿人隐私默认保护，被采纳后进入热门发酵环节，
                {siteInfo.slogan}。
              </p>
              <div className="mt-6 flex flex-wrap gap-3">
                <Link
                  to="/submit"
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-background-50 text-primary-700 text-sm font-medium whitespace-nowrap hover:bg-background-100 transition-colors"
                >
                  <i className="ri-send-plane-fill"></i>
                  我要爆料
                </Link>
                <Link
                  to="/faq"
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-md border border-background-50/60 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-background-50/15 transition-colors"
                >
                  <i className="ri-question-line"></i>
                  投稿前先看看
                </Link>
              </div>
            </div>

            <div className="w-full lg:w-auto shrink-0 grid grid-cols-2 lg:grid-cols-1 gap-3 lg:min-w-[220px]">
              <div className="px-4 py-3 rounded-lg bg-background-50/15 border border-background-50/25">
                <span className="text-xs text-background-50/85">审核轮值</span>
                <p className="mt-1 text-sm font-medium text-background-50">{siteInfo.workingHours}</p>
              </div>
              <div className="px-4 py-3 rounded-lg bg-background-50/15 border border-background-50/25">
                <span className="text-xs text-background-50/85">线索邮箱</span>
                <p className="mt-1 text-sm font-medium text-background-50 break-all">
                  {siteInfo.email}
                </p>
              </div>
            </div>
          </div>
        </div>
      </Reveal>
    </section>
  );
}